import { render, staticRenderFns } from "./interface.vue?vue&type=template&id=5f77aad6&scoped=true&"
import script from "./interface.vue?vue&type=script&lang=js&"
export * from "./interface.vue?vue&type=script&lang=js&"
import style0 from "./interface.vue?vue&type=style&index=0&id=5f77aad6&scoped=true&lang=css&"
import style1 from "./interface.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f77aad6",
  null
  
)

export default component.exports